export const adminResellersQueryKeys = {
  all: ['admin-resellers'],
  list: () => [...adminResellersQueryKeys.all, 'list'],
  detail: (id) => [...adminResellersQueryKeys.all, 'detail', id],
  resellers: () => ['resellers'],
};
